<div
  class="calendar"
  [class.disabled]="disabled"
  [formGroup]="formGroup"
>
  <tui-calendar
    [disabledItemHandler]="disableItems"
    [min]="min"
    [max]="max"
    [showAdjacent]="isShowAdjacentValues"
    [value]="value"
    (dayClick)="handleOnDayClick($event)"
    (monthChange)="handleOnMonthChange($event)"
  ></tui-calendar
></div>
